// ✅ FILE: getImageUrl.js (no fallback logic)
const API_BASE = process.env.REACT_APP_BACKEND_URL.replace(/\/api\/$/, "");

export function getImageUrl(type, filePathOrFilename) {
  if (!filePathOrFilename) return null;

  // If already a full relative path (starts with /uploads)
  if (filePathOrFilename.startsWith("/uploads")) {
    return `${API_BASE}${filePathOrFilename}`;
  }

  // Otherwise, assume it's just a filename and map it to the folder
  let folder = "";
  if (type === "profile") folder = "profilePics";
  else if (type === "cover") folder = "coverPics";
  else if (type === "post") folder = "postPics";
  else return null;

  return `${API_BASE}/uploads/${folder}/${filePathOrFilename}`;
}
